import React from 'react';
import PropTypes from 'prop-types';

import Element from '~/src/components/element/Element';
import HtmlText from '~/src/components/htmlText/HtmlText';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './Poll.module.scss';
import i18nStrings from './Poll.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class Poll extends React.Component {
    renderAnswer = (answer) => {
        return (
            <label key={answer.id}>
                <input name={this.props.id} type="radio" className={css.radio} />
                <span className={css.label}>
                    <Element {...answer} as="span" />
                </span>
            </label>
        );
    };

    render() {
        return (
            <div className={css.poll}>
                <div className={css.titleHeader}>
                    <h2>{getTranslation('poll')}</h2>
                </div>
                <div className={css.title}>
                    <HtmlText htmlText={this.props.question.htmlText} as="h1" />
                </div>
                <div className={css.answers}>{this.props.answers.map(this.renderAnswer)}</div>
                <div className={css.button}>
                    <button>{getTranslation('vote')}</button>
                </div>
            </div>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    Poll.propTypes = {
        type: PropTypes.oneOf(['poll']),
        question: PropTypes.shape({
            type: PropTypes.oneOf(['title']),
            htmlText: PropTypes.string.isRequired
        }).isRequired,
        answers: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired
            })
        ).isRequired
    };
}

export default Poll;
